import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core'
import { MatTableDataSource } from '@angular/material/table'
import { MatSort } from '@angular/material/sort'
import { MatPaginator } from '@angular/material/paginator'
import { fromEvent, debounceTime, distinctUntilChanged, tap } from 'rxjs'
import { DatePipe } from '@angular/common'
import { PropgService } from 'src/app/services/propg-service'
import { InscricaoDetalhes } from 'src/app/models/inscricao-detalhes'
import { PdfViewerComponent } from '../../comum/pdf-viewer/pdf-viewer.component'
import { MatDialog } from '@angular/material/dialog'
import { PlanoViewerComponent } from '../../comum/plano-viewer/plano-viewer.component'
import { DocumentosViewerComponent } from '../../comum/documentos-viewer/documentos-viewer.component'

@Component({
  selector: 'app-propg-inscricoes',
  templateUrl: './propg-inscricoes.component.html',
  styleUrls: ['./propg-inscricoes.component.css'],
  standalone: false
})
export class PropgInscricoesComponent implements AfterViewInit, OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator
  @ViewChild(MatSort) sort!: MatSort
  @ViewChild('input') input!: ElementRef
  totalElements: number = 0

  colunasGrid: string[] = ['id', 'discente', 'disciplina', 'inscricao', 'action']
  dataSource: MatTableDataSource<InscricaoDetalhes> = new MatTableDataSource()

  datepipe: DatePipe = new DatePipe('pt-BR')

  constructor(private propgService: PropgService, public dialog: MatDialog) {}

  ngOnInit(): void {
    this.getData()
  }

  ngAfterViewInit() {
    // server-side search
    fromEvent(this.input.nativeElement, 'keyup')
      .pipe(
        debounceTime(150),
        distinctUntilChanged(),
        tap(() => {
          this.paginator.pageIndex = 0
          this.getData()
        })
      )
      .subscribe()

    // on paginate events, load a new page
    this.paginator?.page.pipe(tap(() => this.getData())).subscribe()
  }

  private getData() {
    this.propgService
      .inscricoes(this.input?.nativeElement.value, this.paginator.pageIndex, this.paginator.pageSize)
      .subscribe(data => {
        this.dataSource = new MatTableDataSource(data['content'])
        this.dataSource.sort = this.sort
        this.totalElements = data['totalElements']
      })
  }

  exportar() {
    this.propgService.inscricoes(this.input?.nativeElement.value, 0, this.totalElements).subscribe(data => {
      let recursos: InscricaoDetalhes[] = data['content']
      let content = `"#","CPF-ALUNO","NOME-ALUNO","CAMPUS","SIGLA","ID-DEPARTAMENTO","NOME-DEPARTAMENTO","ID-DISCIPLINA","NOME-DISCIPLINA","CODIGO-DISCIPLINA","CARGA-HORARIA","DURACAO","DATA","ANO","INSCRICA-SITUACAO","SEMESTRE"\r\n`
      recursos.forEach(row => {
        content += `"${row.id}","${row.cpfAluno}","${row.nomeAluno}","${row.nomeCampus}","${row.siglaCampus}","${
          row.idDepartamento
        }","${row.nomeDepartamento}","${row.idDisciplina}","${row.nomeDisciplina}","${row.codigoDisciplina}","${
          row.cargaHoraria
        }","${row.duracao}","${this.datepipe.transform(row.data, 'dd/MM/YYYY HH:mm:ss')}","${row.ano}","${
          row.inscricaoSituacao
        }","${row.semestre}"\r\n`
      })
      let binaryData = []
      binaryData.push(content)
      let downloadLink = document.createElement('a')
      downloadLink.setAttribute('download', 'inscricoes.csv')
      downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: 'attachment/csv;charset=utf-8;' }))
      document.body.appendChild(downloadLink)
      downloadLink.click()
      downloadLink.remove()
    })
  }

  plano(id: number): void {
    this.propgService.plano(id).subscribe(data => {
      this.dialog.open(PlanoViewerComponent, {
        data: data,
        width: '80%',
        height: '85%',
      })
    })
  }

  documentos(id: number): void {
    this.propgService.documentos(id).subscribe(data => {
      this.dialog.open(DocumentosViewerComponent, {
        data: data,
        width: '50%',
        height: '30%',
      })
    })
  }

  certificadoDiscente(id: number): void {
    this.propgService.certificadoDiscente(id).subscribe(data => {
      let blob = new Blob([data], {
        type: 'application/pdf',
      })
      let url = window.URL.createObjectURL(blob)
      this.dialog.open(PdfViewerComponent, {
        data: {
          titulo: `certificado-discente-${id}.pdf`,
          url: url,
        },
        width: '80%',
        height: '90%',
      })
    })
  }

  certificadoDocente(id: number): void {
    this.propgService.certificadoDocente(id).subscribe(data => {
      let blob = new Blob([data], {
        type: 'application/pdf',
      })
      let url = window.URL.createObjectURL(blob)
      this.dialog.open(PdfViewerComponent, {
        data: {
          titulo: `certificado-docente-${id}.pdf`,
          url: url,
        },
        width: '80%',
        height: '90%',
      })
    })
  }
}
